export default __webpack_public_path__ + "static/media/step_4.11235ad2.jpg";